import { render } from "./detail-pra_pelaksanaan.vue?vue&type=template&id=66d4f208"
import script from "./detail-pra_pelaksanaan.vue?vue&type=script&lang=js"
export * from "./detail-pra_pelaksanaan.vue?vue&type=script&lang=js"

import "./detail-pra_pelaksanaan.vue?vue&type=style&index=0&id=66d4f208&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__